import backToTopStyles from './back-to-top-button';

var editMode = document.querySelector("body.pagemode-edit"), backToTopButton = document.querySelector("#backToTopButton");
function attachClickEvent() {
  backToTopButton && backToTopButton.addEventListener("click", o => { this.scrollToTop(1e3) })
}
function attachScrollEvent() {
  console.log("Scrolling");
  backToTopButton && (window.onscroll = (() => { this.showHideButton() }), window.onload = (() => { this.showHideButton() }))
}
function scrollToTop(o) {
  const t = window.pageYOffset, n = Math.PI / (o / 15), e = t / 2; var c, a = 0, i = setInterval(function () { 0 != window.pageYOffset ? (a += 1, c = e - e * Math.cos(a * n), window.scrollTo(0, t - c)) : clearInterval(i) }, 15)
}
function showHideButton() {
  window.pageYOffset >= window.innerHeight ? backToTopButton.classList.add("show") : backToTopButton.classList.remove("show")
}
